import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainList from './MainList'

const QualityReviewList = () => {
  return (
    <div>
            <Helmet>
               <title>Quality Review </title>

            </Helmet>
            
            <Header />

           <MainList />
            
        </div>
  )
}

export default QualityReviewList